
import React from "react";

import { connect } from 'react-redux';
import { logIn } from '../actions';

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";

import {
    Container, Form,
    FormGroup, Label, Input,
    Button,
} from 'reactstrap';

import './login.css'

import Navbar2 from "components/Navbars/Navbar2.js";
import { thead, tbody } from "variables/general";
import CardFooter from "reactstrap/lib/CardFooter";
import Header from '../components/Navbars/NavbarLogin' 
import Navbar from "reactstrap/lib/Navbar";


import NotificationAlert from "react-notification-alert";


var ContStyle = {
    width:"50%"
  
  }
var formStyle = {
    marginTop: '60px'
}



class Login extends React.Component {
    state = {email:"",password:""}

    notify(place,message) {
        if (!message){
          return ""
        }
        var color = message[0];
        if (color === "success"){
          localStorage.clear()
          window.location.replace("/login")
        }
        var type;
        switch (color) {
          case 'success':
            type = "success";
            break;
          case 'danger':
            type = "danger";
            break;
          case 'warning':
            type = "warning";
          default:
            break;
        }
        var options = {};
        options = {
          place: place,
          message: (
            <div>
              <div style={{height:'70px'}}>
                {message[1]}
              </div>
              
            </div>
          ),
          type: type,
          icon: "now-ui-icons ui-1_bell-53",
          autoDismiss: 10,
        };
        this.refs.notificationAlert.notificationAlert(options);
    }
    

      //prevProps.message.message !== this.props.message.message && 
    componentDidUpdate(prevProps){
        if(prevProps.message.message !== this.props.message.message && this.props.message.message){
            if(this.props.message.message.includes('something went wrong')){
                console.log('server is waking up')
            }
            else{
                this.notify("br",this.props.message.message)
            }
            
        }
    }
    submitLogin = () => {
        this.props.logIn(this.state)
    }
    componentDidMount(){
        this.props.logIn(this.state)
    }
    render() {
        if (this.props.auth.token){
            localStorage.setItem("token",this.props.auth.token)
            localStorage.setItem("user",JSON.stringify(this.props.auth))
            window.location.replace("/dashboard")
        }
        
        return (
        <div className="image">
            <Navbar2 {...this.props} style={{backgroundColor:'rgb(0,0,0)'}}  />
            <Container className="App" align={'center'}>
            <NotificationAlert ref="notificationAlert" />
                <Col xs={12} md={5} align={'center'}>
                    <Card style={{backgroundColor:'rgba(0,0,0,0.4)',padding:'30px',marginTop:'60px',color:'rgb(255,255,240)'}}>
                    <h2>Sign In</h2>
                        <Form className="form" style={formStyle}>
                        <Row>
                            <Col xs={12} md={12}>
                                <FormGroup>
                                <Label style={{color:'rgb(240,240,240)'}}>Email</Label>
                                <Input
                                    style={{height:'35px'}}
                                    type="email"
                                    name="email"
                                    value = {this.state.email}
                                    onChange={e => this.setState({email:e.target.value})}
                                />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                <Label for="examplePassword" style={{color:'rgb(240,240,240)'}}>Password</Label>
                                <Input
                                    style={{height:'35px'}}
                                    type="password"
                                    name="password"
                                    id="examplePassword"
                                    value = {this.state.password}
                                    onChange={e => this.setState({password:e.target.value})}
                                />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="hoverButton">
                          <Col>
                            <Button className="hoverButton" onClick={this.submitLogin} style={{alignItem:'center',backgroundColor:'rgb(255,180,30)'}}>Submit</Button>
                          </Col>
                            
                        </Row>
                            </Form>
                        
                        <Row>
                            <CardFooter>
                                <div class="d-flex justify-content-center links">
                                    Don't have an account?<a href="/signUp">Sign Up</a>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <a href="/password_reset">Forgot your password?</a>
                                </div>
                            </CardFooter>
                        </Row>
                    </Card>
                
                </Col>
                
                
            </Container>
          </div>
        );
      }
    }
    const mapStateToProps = (state) => {
        //console.log(state)
        return {auth:state.auth,message:state.message}
      }
    export default connect(mapStateToProps,{logIn})(Login);
